import { api as com, apiFuns } from 'sw-hic';
let {genStandard} = apiFuns

const api = {
  /**************** 诊疗记录 ****************/
  OpTreatment: apiFuns.genStandard("opTreatment", "/api/op",'',true)
};

export default api;